import { render, staticRenderFns } from "./UnionPreview.vue?vue&type=template&id=20c00ad0&scoped=true"
import script from "./UnionPreview.vue?vue&type=script&lang=js"
export * from "./UnionPreview.vue?vue&type=script&lang=js"
import style0 from "./UnionPreview.vue?vue&type=style&index=0&id=20c00ad0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c00ad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c00ad0')) {
      api.createRecord('20c00ad0', component.options)
    } else {
      api.reload('20c00ad0', component.options)
    }
    module.hot.accept("./UnionPreview.vue?vue&type=template&id=20c00ad0&scoped=true", function () {
      api.rerender('20c00ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/UnionPreview.vue"
export default component.exports